import React, { useState, useEffect } from "react";
import Flexbox from "flexbox-react";
import { Dialog, Icon, Tooltip, Position } from "@blueprintjs/core";
import {
  FilledButton, OutlinedButton,
} from "../buttons-20250224T111359Z-001/buttons";
import ConfirmationDialog from "../../views/ConfirmationDialog";
import Cookies from "js-cookie";
import axios from "axios";
import ToastStore from "../../stores/ToastStore";

const DUMMY_PASSWORD = "PeopleGoal@123";

const AccountDummyUsers = ({ refreshUsers }) => {
  const [isAddDummyUsersDialogOpen, setIsAddDummyUsersDialogOpen] = useState(false);
  const [isRemoveDummyUsersDialogOpen, setIsRemoveDummyUsersDialogOpen] = useState(false);
  const [dummyUsersExist, setDummyUsersExist] = useState(false);
  const [isLoadingStatus, setIsLoadingStatus] = useState(true);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    fetchDummyUserStatus();
  }, []);

  const fetchDummyUserStatus = () => {
    setIsLoadingStatus(true);

    axios
      .get(
        `${Cookies.get("apiEnv")}/dummy_users/check_dummy_users_exist`
      )
      .then((response) => {
        setDummyUsersExist(response.data.dummy_users_exist);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setIsLoadingStatus(false);
      });
  };

  const showCopied = () => {
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  const fallbackCopy = () => {
    const textArea = document.createElement("textarea");
    textArea.value = DUMMY_PASSWORD;
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    textArea.style.top = "-9999px";

    document.body.appendChild(textArea);

    textArea.focus();
    textArea.select();

    try {
      document.execCommand("copy");
      showCopied();
    } catch (err) {
      ToastStore.showToast("Failed to copy password", "danger");
    }

    document.body.removeChild(textArea);
  };

  const copyPassword = () => {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard
        .writeText(DUMMY_PASSWORD)
        .then(() => {
          showCopied();
        })
        .catch(() => {
          fallbackCopy();
        });
    } else {
      fallbackCopy();
    }
  };

  const addDummyUsers = () => {
    setIsLoadingStatus(true);
    axios
      .get(`${Cookies.get("apiEnv")}/dummy_users/add`)
      .then(() => {
        setIsLoadingStatus(false);
        setIsAddDummyUsersDialogOpen(false);
        setDummyUsersExist(true);

        refreshUsers && refreshUsers();

        ToastStore.showToast(
          "Dummy users added successfully",
          "success"
        );
      })
      .catch((error) => {
        setIsLoadingStatus(false);
        ToastStore.showToast(
          error?.response?.data?.error ||
          "Failed to add dummy users",
          "danger"
        );

        setIsLoadingStatus(false);
        setIsAddDummyUsersDialogOpen(false);
      });
  };

  const removeDummyUsers = () => {
    setIsLoadingStatus(true);
    axios
      .get(`${Cookies.get("apiEnv")}/dummy_users/remove`)
      .then(() => {
        setIsLoadingStatus(false);
        setIsRemoveDummyUsersDialogOpen(false);
        setDummyUsersExist(false);

        refreshUsers && refreshUsers();

        ToastStore.showToast(
          "Dummy users removed successfully",
          "success"
        );
      })
      .catch((error) => {
        setIsLoadingStatus(false);
        ToastStore.showToast(
          error?.response?.data?.error ||
          "Failed to remove dummy users",
          "danger"
        );

        setIsRemoveDummyUsersDialogOpen(false);
      });
  };

  return (
    <>
      <Flexbox
        flexGrow={1}
        justifyContent="flex-end"
        style={{ marginBottom: "10px" }}
      >
        {!isLoadingStatus &&
          (dummyUsersExist ? (

            <Flexbox
              flexGrow={1}
              justifyContent="flex-end"
              style={{ marginBottom: "10px" }}
            >
              <Flexbox
                flexDirection="column"
                alignItems="flex-end"
              >
                <OutlinedButton
                  text="Remove Demo Users"
                  onClick={() => setIsRemoveDummyUsersDialogOpen(true)}
                  style={{ width: "185px" }}
                />

                <Flexbox
                  alignItems="center"
                  style={{
                    marginTop: "8px",
                    fontSize: "13px",
                    color: "#5C7080",
                  }}
                >

                  <span>Password for demo users:&nbsp;</span>
                  <span
                    style={{
                      fontWeight: 600,
                      color: "#182026",
                    }}
                  >
                    {DUMMY_PASSWORD}
                  </span>
                </Flexbox>
              </Flexbox>
            </Flexbox>

          ) : (
            <Tooltip
              content="Add demo users to your account for testing and evaluation purposes."
              position={Position.TOP}
              boundary="viewport"   
              interactionKind="hover"
            >
              <div style={{ display: "inline-block" }}>
                <FilledButton
                  text="Add Demo Users"
                  onClick={() => setIsAddDummyUsersDialogOpen(true)}
                  style={{ width: "185px" }}
                />
              </div>
            </Tooltip>
          ))}
      </Flexbox>

      <Dialog
        isOpen={isAddDummyUsersDialogOpen}
        onClose={() =>
          setIsAddDummyUsersDialogOpen(false)
        }
        title="Add Demo Users"
        portalContainer={document.body}
      >
        <Flexbox
          flexDirection="column"
          style={{ padding: "20px" }}
        >
          <p
            style={{
              marginTop: 0,
              color: "#394B59",
              fontSize: "15px",
            }}
          >
            This action will add demo users to your account.
          </p>
          <p>
            This will add a set of demo users to your account for testing and evaluation purposes. These users will appear in your user list just like regular users and can be removed at any time using the "Remove Demo Users" option.
          </p>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "#F8FAFC",
              border: "1px solid #D8E1EA",
              borderRadius: "8px",
              padding: "12px 14px",
              marginBottom: "20px",
            }}
          >
            <span
              style={{
                color: "#5C7080",
                fontSize: "14px",
              }}
            >
              Password for demo users:{" "}
              <strong style={{ color: "#182026", fontWeight: 600, }}
              >
                {DUMMY_PASSWORD}
              </strong>
            </span>

            <div
              onClick={copyPassword}
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                color: "#5C7080",
                fontWeight: 600,
                gap: "6px",
                userSelect: "none",
              }}
            >
              <Icon icon={copied ? "tick" : "duplicate"} iconSize={14} />
              {copied ? "Copied" : "Copy"}
            </div>
          </div>

          <Flexbox>
            <FilledButton
              text={isLoadingStatus ? "Adding..." : "Add"}
              onClick={addDummyUsers}
              style={{ marginRight: "10px", minWidth: "100px" }}
              disabled={isLoadingStatus}
            />
            <OutlinedButton
              text="Cancel"
              onClick={() =>
                setIsAddDummyUsersDialogOpen(false)
              }
            />
          </Flexbox>
        </Flexbox>
      </Dialog>

      <Dialog
        isOpen={isRemoveDummyUsersDialogOpen}
        onClose={() =>
          setIsRemoveDummyUsersDialogOpen(false)
        }
        title="Remove Demo Users"
        onConfirm={removeDummyUsers}
        onCancel={() =>
          setIsRemoveDummyUsersDialogOpen(false)
        }
      >
        <Flexbox flexDirection="column" style={{ padding: "20px" }}>
          <p style={{ marginTop: 0, color: "#394B59", fontSize: "15px" }}>
            Are you sure you want to remove all demo users from your account?<br /> This action will permanently delete all demo users that were added for testing purposes.
          </p>
          <Flexbox>
            <FilledButton
              text={isLoadingStatus ? "Removing..." : "Remove"}
              onClick={removeDummyUsers}
              style={{ marginRight: "10px" }}
              disabled={isLoadingStatus}
            />
            <OutlinedButton
              text="Cancel"
              onClick={() => setIsRemoveDummyUsersDialogOpen(false)}
            />
          </Flexbox>
        </Flexbox>
      </Dialog>
    </>
  );
};

export default AccountDummyUsers;